<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    

  <circle fill="none" stroke="currentColor" stroke-opacity="0.2" stroke-width="3" cx="16" cy="16" r="14.5"></circle>
  <path d="M32,16 L28.9991161,16 C28.9991161,8.85823059 23.2269528,3 16.0093878,3 L16,0 C24.836556,0 32,7.163444 32,16 Z">
    <animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="1s" repeatCount="indefinite"/>
  </path>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyLoaderSpinner',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 32 32',
    },
  },
};
</script>

<style scoped>
  
</style>